// extracted by css-extract-rspack-plugin
export default {"containerOnlyText":"container-only-text--xCSd9tBV2U21_c2f","containerWithIcon":"container-with-icon--emHUuQByc5IcVpYq","playIcon":"play-icon--Q0m3MB9fpsE6jfD1"};